import angular from 'angular';

angular.module('app.core').factory('ModelUpdateNotAllowedModal', ModelUpdateNotAllowedModal);

export default class ModelUpdateNotAllowedModal {
    constructor($uibModal, cancelFunction) {
        this.$uibModal = $uibModal;
        this.cancelFunction = cancelFunction;
    }

    // Popup affichée dans le cas où la sauvegarde d'un modèle spécifique n'est pas autorisée à cause d'attributs manquants par rapport au modèle standard.
    openModelUpdateNotAllowedModal(models) {
        this.$uibModal
            .open({
                component: 'modalMissingDocumentModelAttribute',
                size: 'md',
                resolve: {
                    models: () => {
                        return models;
                    },
                },
            })
            .result.then(
                () => {},
                () => {
                    this.cancelFunction();
                }
            );
    }
}
